
export function isDocFileType (fileType) {
  return fileType === 'doc'
}
